import {createContext} from 'react';

const LocationInfoContext = createContext({});

export const LocationInfoProvider = LocationInfoContext.Provider;

export default LocationInfoContext;
